import {
	ADMINCREATEFEEMAPPING_SUCCESS,
	ADMINCREATEFEEMAPPING_FAILED,
	RESET_ADMINCREATEFEEMAPPING,
	LOADING_ADMINCREATEFEEMAPPING,
	NETWORK_ERROR_ADMINCREATEFEEMAPPING
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAdminCreateFeeMapping = () => {
	return { type: RESET_ADMINCREATEFEEMAPPING };
};

const adminCreateFeeMapping = (userData, authTokenIs) => async (dispatch) => {
	dispatch({ type: LOADING_ADMINCREATEFEEMAPPING });
	await adminServices
		.post("createFeeMapping", userData, { headers: { AuthToken: authTokenIs } })
		.then((res) => {
			switch (res.data.status) {
				case "success":
					dispatch(adminCreateFeeMappingsuccess(res.data));
					break;
				default:
					dispatch(adminCreateFeeMappingFailed(res.data));
					break;
			}
		})
		.catch((err) => {
			dispatch({
				type: NETWORK_ERROR_ADMINCREATEFEEMAPPING,
				payload: err
			});
		});
};
function adminCreateFeeMappingsuccess(data) {
	return {
		type: ADMINCREATEFEEMAPPING_SUCCESS,
		payload: data
	};
}
function adminCreateFeeMappingFailed(data) {
	return {
		type: ADMINCREATEFEEMAPPING_FAILED,
		payload: data
	};
}

export { resetAdminCreateFeeMapping, adminCreateFeeMapping };
